import RegionOverlay from "../../../rendering/region-overlay";

class DrawState {
    constructor() {
        this.beginPosition = new THREE.Vector3();
        this.plane = new THREE.Plane();
        this.mesh = null;
        this.parentMatrixWorldInverse = new THREE.Matrix4();
        this.isCreatingBlob = false;
    }
}

class RenderingState {
    constructor() {
        this.locked = false;
        this.labelsTransitioning = false;
        this.labelsLerping = false;
    }
}

class ModifyState {
    constructor() {
        this.type = MODIFY_TYPE.MODIFY_NONE;
        this.vector = new THREE.Vector3();
        this.quaternion = new THREE.Quaternion();
    }
}

class CalloutState {
    constructor() {
        this.invalid = [];
        this.left = [];
        this.right = [];
    }
}

class LastState {
    constructor() {
        this.object = null;
        this.intersection = null;
        this.state = {};
    }
}

class RegionState {
    constructor() {
        this.isDisplaying = false;
        this.selected = null;
        this.overlay = new RegionOverlay();
    }
}

class HighlightState {
    constructor() {
        this.highlighted = null;
        this.isHighlight2d = false;
    }
}

class LabelState {
    constructor() {
        this.visible = false;
        this.obstructedBy2d = false;
        this.positionOriginal = new THREE.Vector3();
        this.positionDesired = new THREE.Vector3();
        this.rayValid = new THREE.Vector2();
        this.rayCurrent = new THREE.Vector2();
        this.lerp = 1;
        this.lerping = false;
        this.depth = 0;
    }
}

class LayoutState {
    constructor() {
        this.labelActivator = null;
        this.layoutController = null;
        this.isCallout = null;
        this.layoutName = null
    }
}

const MODIFY_TYPE = Object.freeze({
    MODIFY_NONE: "none",
    MODIFY_ADD: "add",
    MODIFY_SCALE: "scale",
    MODIFY_MOVE: "move",
    MODIFY_ADD_CONTINOUS: "add_continous"
});

export { DrawState, ModifyState, HighlightState, LabelState, RegionState, LastState, CalloutState, RenderingState, LayoutState, MODIFY_TYPE };